import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';

/**
 * Chrome-free layout for screens that fill a display: an in-store calling board
 * on a TV, a kitchen screen, a queue board. Anything a customer reads from
 * across the room wants every pixel, so this layout deliberately renders no
 * topbar, navigation or footer.
 */
const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column'
  }
}));

const Fullscreen = props => {
  const { children } = props;

  const classes = useStyles();

  return <main className={classes.root}>{children}</main>;
};

Fullscreen.propTypes = {
  children: PropTypes.node
};

export default Fullscreen;
